import React from 'react';
import { connect } from 'react-redux';
import CoffeeSvg from '../../../shared/UI/coffeeSvg';
import RunningSvg from '../../../shared/UI/runningSvg';

const GapCard = (props) => {

    const { itinerary, index } = props;
    const _nextCity = (itinerary[index + 1].type === "city" || itinerary[index + 1].type === "start") ? itinerary[index + 1].to : itinerary[index + 1].name;
    const _gapType = itinerary[index].message;

    return (
        <div className={`panel small-panel extends no-border flex ${_gapType.toLowerCase()} mb1`}>
            <div className="flex items-center col-12">
                <div className="flex justify-center col-12">
                    <p className={`f-size-14 ${_gapType.toLowerCase()} ${_gapType === "SAME_DAY_ROUTE_START" ? 'white-text' : 'black-text'}`}>
                        {
                            _gapType === "ROUTE_START" && (
                                <>
                                <CoffeeSvg fill="#ffcc00" clazz="mr2"/>
                                <span className="bold">Itinerary Break!</span> <span className="regular">Make your way to {_nextCity}</span>
                                </>
                            )
                        }

                        {
                            _gapType === "SAME_DAY_ROUTE_START" && (
                                <>
                                    <RunningSvg fill="#ffffff" clazz="mr2 xs-hide"/>
                                    <span className="bold">Quick!</span> <span className="regular">Make your own way to {_nextCity} on the</span> <span className="bold">sameday!</span>
                                </>
                            )
                        }
                    </p>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return{
        itinerary:state.currentBooking.itinerary
    }
}

export default connect(mapStateToProps, null)(GapCard);